import * as _ from 'lodash';

import * as types from './types';
import {
  RestrictionType,
  ChargeTypeMode,
} from '../../helpers/SiteSetupConstants';
import { SITESETUP_CLEAR_FETCHED } from '../types';

const INITIAL_STATE = {
  data: [],
  initalData: [],
  loading: false,
  restrictionType: RestrictionType.None,
  initialRestrictionType: RestrictionType.None,
  fetched: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SITESETUP_CLEAR_FETCHED:
      return {
        ...state,
        fetched: false,
      };

    case types.SITESETUP_CHARGE_BY_STATUS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case types.SITESETUP_SET_NO_RESTRICTION_CHARGE_BY_STATUS: {
      const copiedData = _.cloneDeep(state.data);

      copiedData.forEach(x => {
        if (x.Status === action.payload) {
          x.NoRestrictions = !x.NoRestrictions;
          x.MealCount = '';
        }
      });

      return {
        ...state,
        data: copiedData,
      };
    }

    case types.SITESETUP_EDIT_GRID_LINE_CHARGE_BY_STATUS: {
      const copiedData = _.cloneDeep(state.data);

      copiedData.forEach(x => {
        if (x.Status === action.payload.status) {
          x.MealCount = action.payload.newValue;
          if (action.payload.newValue === '') {
            x.NoRestrictions = true;
          }
        }
      });

      return {
        ...state,
        data: copiedData,
      };
    }

    case types.SITESETUP_SET_RESTRICTIONS_CHARGE_BY_STATUS:
      return {
        ...state,
        restrictionType: action.payload,
      };

    case types.SITESETUP_CLEAR_CHARGE_BY_STATUS:
      return {
        ...state,
        data: [],
      };

    case types.SITESETUP_GET_CHARGE_BY_STATUS: {
      const data = _.filter(action.payload, {
        ChargeByStatusMode: ChargeTypeMode.NumberOfMeals,
      });
      const initialData = [];

      data.forEach(item => {
        initialData.push({
          status: item.Status,
          mealCount: item.MealCount,
        });
      });

      const restrictionType =
        data &&
        data.length > 0 &&
        _.find(data, x => x.MealCount && x.MealCount > 0)
          ? RestrictionType.Site
          : RestrictionType.None;

      return {
        ...state,
        data,
        initialData,
        restrictionType,
        initialRestrictionType: restrictionType,
        fetched: true,
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/chargeLimit/reducer.js